module.exports = __webpack_public_path__ + "static/media/slide2.bee36bb7.jpg";